import { render, staticRenderFns } from "./materialAdd.vue?vue&type=template&id=70a27045&scoped=true"
import script from "./materialAdd.vue?vue&type=script&lang=js"
export * from "./materialAdd.vue?vue&type=script&lang=js"
import style0 from "./materialAdd.vue?vue&type=style&index=0&id=70a27045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a27045",
  null
  
)

export default component.exports